import {
  CheckCircleOutlined,
  ErrorOutlineOutlined,
  InfoOutlined,
  ReportProblemOutlined,
} from '@mui/icons-material'
import React, { type PropsWithChildren } from 'react'

import { TextBodyBold } from '../../data-display/typography/Typography'

import { Actions, ChildrenWrapper, Content, StyledAlert } from './Alert.styles'

export type Severity = 'success' | 'warning' | 'error' | 'info'
export type Size = 'xs' | 'small' | 'medium'

export type AlertProps = {
  severity: Severity
  title?: string
  actions?: React.ReactNode
  size?: Size
  icon?: React.ReactNode | false
  'data-testid'?: string
}

export const Alert = ({
  severity,
  title,
  actions,
  size = 'medium',
  children,
  icon,
  'data-testid': dataTestId,
}: PropsWithChildren<AlertProps>) => {
  const icons: Record<Severity, React.JSX.Element> = {
    success: <CheckCircleOutlined />,
    warning: <ReportProblemOutlined />,
    error: <ErrorOutlineOutlined />,
    info: <InfoOutlined />,
  }

  const getIcon = () => {
    if (icon === false) {
      return icon
    }
    return icon ? icon : icons[severity]
  }

  return (
    <StyledAlert
      variant="outlined"
      icon={getIcon()}
      severity={severity}
      size={size}
      data-testid={dataTestId}
    >
      <Content>
        {title && <TextBodyBold>{title}</TextBodyBold>}
        <ChildrenWrapper>{children}</ChildrenWrapper>
      </Content>
      {actions && <Actions>{actions}</Actions>}
    </StyledAlert>
  )
}
